import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { history } from '../../';

import Grid from '@material-ui/core/Grid';

import pushToGTM, { pageLoadGA4Tag } from '../../utils/analytics/gtm';
import { tabRoutes } from '../../routes';
import tabbarSlice from '../../components/Tabbar/tabbarSlice';
import BomTable from '../../components/BomTable';
import { localView } from '../../utils/analytics/local';

const BomPage = () => {
	const disabledTabs = useSelector(state => state.tabbar.disabledTabs);
	const partNumber = useSelector(state => state.selectedDesign.detail.rankingParameters.partNumber);
	const dispatch = useDispatch();

	useEffect(() => {
		localView('Bom', partNumber);
		pushToGTM(pageLoadGA4Tag('BOM'));

		if (disabledTabs.BOM) {
			if (disabledTabs.Select) {
				history.push(tabRoutes.find(route => route.name === 'Inputs').path);
			} else {
				history.push(tabRoutes.find(route => route.name === 'Select').path);
			}
		} else {
			dispatch(tabbarSlice.actions.setProgressActive(false));
		}
	}, [disabledTabs, dispatch]);

	return (
		<Grid container alignItems="center" justify="center">
			<Grid item xs lg={12} xl={10}>
				<BomTable />
			</Grid>
		</Grid>
	);
};

export default BomPage;
